import { Circle, DragIndicatorSharp, Flag } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import TestCycleProgressBar from '../../elements/common/ProgressBar';
import FormattedJsonDisplay, {
  formatDate,
  formatElapsedTime,
  getDateAndTime,
  getPriorityColor,
  renderLinks,
} from '../../../lib/utils';
import { Badge } from 'react-bootstrap';
import Label from '../../elements/Label';
import NumberOfIterations from '../../elements/common/NumberOfIterations';
import NumberOfTestCases from '../../elements/common/NumberOfTestCases';
import { Typography,Tooltip } from '@mui/material';
import LinkedIssuesTooltip from '../../elements/common/LinkedIssuesTooltip';
import { MobileResponsive } from '../../../assets/icons/mobile-responsive';
import { NativeMobile } from '../../../assets/icons/native-mobile';
import { HybridMobile } from '../../../assets/icons/hybrid-mobile';
import { WebIcon } from '../../../assets/icons/web-icon';
import { MlIcon } from '../../../assets/icons/ml-icon';
import { ETLIcon } from '../../../assets/icons/etl-icon';
import { DatabaseIcon } from '../../../assets/icons/database-icon';
import { ApiIcon } from '../../../assets/icons/api-icon';
import DetailsPageLink from '../../elements/DetailsPageLink';
import { IssueTypeIcon } from '../../elements/IssueTypeIcon';
import { renderCountryFlagsGrid } from '../../../static-data/formatCountryOptions';
export const testCaseTableHead = [
  {
    key: 'key',
    label: 'Key',
    sortable: true,
    paramToPass: 'id',
    linkToId: 'testcases',
    formatContent: (row) => (
      <DetailsPageLink
        to={`/project/${row.gainss_project_id}/testcases/${row.key}`}
        label={row.key}
      />
    ),
  },
  {
    key: 'summary',
    label: 'Description',
    sortable: true,
    formatContent: (row) => (
      <span title={row?.summary}>
        {row?.summary}
      </span>
    ),
  },
  {
    key: 'priorityName',
    label: 'Priority',
    sortable: true,
    formatContent: (row) => (
      <span
        className="btn-transparent"
        title={row?.priority?.name}
        style={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'default',
          padding: '10px',
        }}>
        <Flag sx={{ color: row?.priority?.color }} />
      </span>
    ),
  },
  {
    key: 'statusName',
    label: 'Status',
    sortable: true,
    formatContent: (row) => (
      <span
        title={row?.status?.name}
        style={{
          display: 'flex',
          alignItems: 'center',
        }}>
        <Label color={row?.status?.color} name={row?.status?.name} />
      </span>
    ),
  },
  // {
  //   key: 'technology_layer',
  //   label: 'Technology Layer',
  //   hoverText: 'Technology Layer',
  //   sortable: true,
  // },
  {
    key: 'testSuites',
    label: 'Test Suites',
    hoverText: 'Test Suites',
    sortable: true,
  },
  {
    key: 'module',
    label: 'Module',
    hoverText: 'Functional Module',
    sortable: true,
  },
  {
    key: 'label',
    label: 'Label',
    hoverText: 'Label',
    sortable: true,
    formatContent: (row) => <span title={row?.label}>{row?.label || '-'}</span>,
  },
  {
    key: 'owner',
    label: 'Author',
    sortable: true,
  },
  {
    key: 'updated_at',
    label: 'Last Updated',
    sortable: true,
    formatContent: (row) => <>{getDateAndTime(row.updated_at)}</>,
  },
  {
    key: 'geographies',
    label: 'Country',
    sortable: false,
    formatContent: (row) => renderCountryFlagsGrid(row.country),
  },
  {
    key: 'platforms',
    label: 'Platforms',
    sortable: false,
    formatContent: (row) => (
      <span>
        {row?.platforms?.length > 0 ? (
          <>
            {row?.platforms?.includes('Mobile Responsive') && (
              <span title="Mobile Responsive">
                <MobileResponsive />
              </span>
            )}
            {row?.platforms?.includes('Native Mobile App') && (
              <span title="Native Mobile App">
                <NativeMobile />
              </span>
            )}
            {row?.platforms?.includes('Hybrid Mobile App') && (
              <span title="Hybrid Mobile App">
                <HybridMobile />
              </span>
            )}
            {row?.platforms?.includes('Web') && (
              <span title="Web">
                <WebIcon />
              </span>
            )}
            {row?.platforms?.includes('API') && (
              <span title="API">
                <ApiIcon />
              </span>
            )}
            {row?.platforms?.includes('ML Algorithms') && (
              <span title="ML Algorithms">
                <MlIcon />
              </span>
            )}
            {row?.platforms?.includes('ETL') && (
              <span title="ETL">
                <ETLIcon />
              </span>
            )}
            {row?.platforms?.includes('Database Testing') && (
              <span title="Database Testing">
                <DatabaseIcon />
              </span>
            )}
          </>
        ) : (
          <span>-</span>
        )}
      </span>
    ),
  },
    {
    key: 'technologyLayer',
    label: 'Technology Layer',
    hoverText: 'Technology Layer',
    sortable: false,
    formatContent: (row) => <span>{row?.technologyLayer || '-'}</span>,
  },
  {
    key: 'reviewer',
    label: 'Reviewer',
    sortable: true,
  },
  {
    key: 'approved_by',
    label: 'Approved By',
    sortable: true,
  },
{
  key: 'candidateForAutomation',
  label: 'Candidate for Automation',
  hoverText: 'Candidate for Automation',
  sortable: true,
  formatContent: (row) => (
    <span>
      {row?.candidateForAutomation === true ? 'Yes' : row?.candidateForAutomation === false ? 'No' : '-'}
    </span>
  ),
},
  {
    key: 'isAutomated',
    label: 'Is Automated',
    hoverText: 'Is Automated',
    sortable: true,
   formatContent: (row) => <span>{row?.isAutomated || '-'}</span>,
  },
];

export const tableHeader = [
  {
    key: 'key',
    label: 'Key',
    sortable: true,
    paramToPass: 'id',
    linkToId: 'testcases',
    formatContent: (row) => (
      <>
        {row.is_archived ? (
          row.key
        ) : (
          <Link
            target="_blank"
            to={`/project/${row.gainss_project_id}/testcases/${row.key}`}>
            {row.key}
          </Link>
        )}
      </>
    ),
  },
  {
    key: 'summary',
    label: 'Description',
    sortable: true,
    formatContent: (row) => (
      <span title={row?.summary}>
        {row?.summary}
      </span>
    ),
  },
  {
    key: 'priority',
    label: 'Priority',
    sortable: true,
    formatContent: (row) => (
      <span
        title={row?.priority?.name}
        style={{
          display: 'flex',
          alignItems: 'center',
        }}>
        <Flag sx={{ color: row?.priority?.color }} />
      </span>
    ),
  },
  {
    key: 'status',
    label: 'Status',
    sortable: true,
    formatContent: (row) => (
      <span
        title={row?.status?.name}
        style={{
          display: 'flex',
          alignItems: 'center',
        }}>
        <Label color={row?.status?.color} name={row?.status?.name} />
      </span>
    ),
  },
  {
    key: 'technology_layer',
    label: 'Technology Layer',
    hoverText: 'Technology Layer',
    sortable: true,
  },
  {
    key: 'module',
    label: 'Module',
    hoverText: 'Module',
    sortable: true,
    formatContent: (row) => row?.module?.name || '-',
  },
  {
    key: 'executions',
    label: 'Last Execution Details',
    sortable: false,
    formatContent: (row) => (
      <>
        <span
          style={{
            display: 'inline-flex',
            gap: '1rem',
            whiteSpace: 'nowrap',
          }}>
          {row.executions?.length > 0 ? (
            <>
              <Label
                color={row?.executions[0]?.status_details?.color}
                name={row?.executions[0]?.status_details?.name}
              />
              {row?.executions[0]?.status_details?.name !== 'Not Executed' && (
                <span>{getDateAndTime(row?.executions[0]?.updated_at)}</span>
              )}
            </>
          ) : (
            '-'
          )}
        </span>
      </>
    ),
  },
];

export const testCasestableHeader = [
  {
    key: 'key',
    label: 'Key',
    sortable: true,
    paramToPass: 'id',
    linkToId: 'testcases',
    formatContent: (row) => (
      <>
        {row.is_archived ? (
          row.key
        ) : (
          <Link
            target="_blank"
            to={`/project/${row.gainss_project_id}/testcases/${row.key}`}>
            {row.key}
          </Link>
        )}
      </>
    ),
  },
  {
    key: 'summary',
    label: 'Description',
    sortable: true,
    formatContent: (row) => (
       <span title={row?.summary}>
        {row?.summary}
      </span>
    ),
  },
  {
    key: 'priority',
    label: 'Priority',
    sortable: true,
    formatContent: (row) => (
      <span
        title={row?.priority?.name}
        style={{
          display: 'flex',
          alignItems: 'center',
        }}>
        <Flag sx={{ color: row?.priority?.color }} />
      </span>
    ),
  },
  {
    key: 'status',
    label: 'Status',
    sortable: true,
    formatContent: (row) => (
      <span
        title={row?.status?.name}
        style={{
          display: 'flex',
          alignItems: 'center',
        }}>
        <Label color={row?.status?.color} name={row?.status?.name} />
      </span>
    ),
  },
  {
    key: 'technology_layer',
    label: 'Technology Layer',
    hoverText: 'Technology Layer',
    sortable: true,
    formatContent: (row) => row?.technology_layer || '-',
  },
  {
    key: 'module',
    label: 'Module',
    hoverText: 'Module',
    sortable: true,
    formatContent: (row) => row?.module?.name || '-',
  },
  {
    key: 'labelNames',
    label: 'Labels',
    sortable: true,
    hoverText: 'Labels',
    formatContent: (row) =>
      row?.labelNames?.length > 0 ? row?.labelNames?.join(', ') : '-',
  }
];

export const tableHeaderTestCycles = [
  {
    key: 'key',
    label: 'Key',
    sortable: true,
    paramToPass: 'id',
    linkToId: 'testcycles',
    formatContent: (row) => (
      <DetailsPageLink
        to={`/project/${row.gainss_project_id}/testcycles/${row.key}?type=executions`}
        label={row.key}
      />
    ),
  },
  {
    key: 'name',
    label: 'Name',
    sortable: true,
    paramToPass: 'id',
    formatContent: (row) => (
      <>
        <p
          title={row?.name}
          className="ellipsis mb-0"
          style={{ lineHeight: '20px' }}>
          {row?.name?.length > 35
            ? `${row?.name?.substring(0, 35)} ...`
            : row?.name}
          <br />
          <span style={{ fontSize: '12px' }}>
            {row?.platforms && row?.platforms.length > 0
              ? `${row?.platforms[0]}`
              : ''}{' '}
            {row?.sub_platforms && row?.sub_platforms.length > 0
              ? ` | ${row?.sub_platforms[0]}`
              : ''}{' '}
            {row?.browsers && row?.browsers.length > 0
              ? `| ${row?.browsers[0]}`
              : ''}
          </span>
        </p>
      </>
    ),
  },
  {
    key: 'type',
    label: 'Type',
    sortable: false,
    hoverText: 'Test cycle type',
    formatContent: (row) => <span title={row.type}>{row.type.charAt(0)}</span>,
  },
  {
    key: 'status',
    label: 'Status',
    sortable: false,
    formatContent: (row) => (
      <span
        title={row?.status?.name}
        style={{
          display: 'flex',
          alignItems: 'center',
        }}>
        <Label color={row?.status?.color} name={row?.status?.name} />
      </span>
    ),
  },
  {
    key: 'totalAssociatedTestCases',
    label: 'Test Cases',
    sortable: false,
    formatContent: (row) => {
      return (
        <NumberOfTestCases
          statusesData={row.statusCounts}
          testCycleKey={row.key}
          totalTestCases={row.totalAssociatedTestCases}
        />
      );
    },
  },
  {
    key: 'totalIterations',
    label: 'Iterations',
    sortable: false,
    hoverText: 'Total number of iterations',
    formatContent: (row) => {
      return (
        <NumberOfIterations
          statusesData={row.statusCounts}
          testCycleId={row.id}
          totalIterations={row.totalIterations}
          latestIterationExecutions={row.latestIterationExecutions}
        />
      );
    },
  },
  {
    key: 'progress',
    label: 'Progress',
    formatContent: (row) => {
      return (
        <TestCycleProgressBar
          statusesData={row.statusCounts}
          testCasesWithNoExecutions={row.testCasesWithNoExecutions}
        />
      );
    },
  },
  {
    key: 'lastUpdated',
    label: 'Last Executed ',
    sortable: true,
    formatContent: (row) => {
      return row.lastUpdated === 'Not Executed' ? (
        <Typography className="text-muted">{row.lastUpdated}</Typography>
      ) : (
        row.lastUpdated
      );
    },
  },
  {
    key: 'geographies',
    label: 'Country',
    sortable: false,
    formatContent: (row) => renderCountryFlagsGrid(row.geographies),
  },
];

export const tableHeaderTestPlans = [
  {
    key: 'key',
    label: 'Key',
    sortable: true,
  },
  {
    key: 'name',
    label: 'Name',
    sortable: true,
  },
  {
    key: 'status',
    label: 'Status',
    sortable: true,
    formatContent: (row) => (
      <span
        title={row?.status?.name}
        style={{
          display: 'flex',
          alignItems: 'center',
        }}>
        <Circle color={row?.status?.color} />
        <span style={{ marginLeft: '8px' }}>{row?.status?.name}</span>
      </span>
    ),
  },
];

export const singleViewPageTabs = [
  {
    key: 'details',
    label: 'Details',
  },
  {
    key: 'testscripts',
    label: 'Test Steps',
  },
  {
    key: 'execution',
    label: 'Execution',
  },
  {
    key: 'traceability',
    label: 'Traceability',
  },
  {
    key: 'attachments',
    label: 'Attachments',
  },
  {
    key: 'comments',
    label: 'Comments',
  },
  {
    key: 'history',
    label: 'History',
  },
];

export const archiveViewPageTabs = [
  {
    key: 'details',
    label: 'Details',
  },
  {
    key: 'history',
    label: 'History',
  },
];

export const singleTestCyclePageTabs = [
  {
    key: 'details',
    label: 'Details',
  },
  {
    key: 'executions',
    label: 'Executions',
  },
  {
    key: 'testcases',
    label: 'Test Cases',
  },
  {
    key: 'traceability',
    label: 'Linked Issues',
  },
  {
    key: 'reports',
    label: 'Reports' 
  },
  {
    key: 'attachments',
    label: 'Attachments',
  },
  {
    key: 'comments',
    label: 'Comments',
  },
  {
    key: 'history',
    label: 'History',
  },
];

export const testCycleTestCaseTableHeaders = [
  {
    key: 'key',
    label: 'Key',
    sortable: true,
  },
  {
    key: 'description',
    label: 'Description',
    sortable: true,
    paramToPass: 'id',
    linkToId: 'testcases',
  },
  {
    key: 'assigned_to',
    label: 'Assigned To',
    sortable: true,
  },
  {
    key: 'environment',
    label: 'Environment',
    sortable: true,
  },
  {
    key: 'iterations',
    label: 'Iterations',
    sortable: true,
  },
  {
    key: 'module',
    label: 'Module',
    sortable: true,
  },
  {
    key: 'suites',
    label: 'Test Suites',
    sortable: true,
  },
  {
    key: 'executionStatus',
    label: 'Last Execution Status',
    hoverText: 'Final execution status of the test case',
    sortable: true,
  },
];

const bytesToSize = (bytes) => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return 'n/a';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
  if (i === 0) return `${bytes} ${sizes[i]}`;
  return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
};

export const attachmentTableHeaders = [
  {
    key: 'file_name',
    label: 'File Name',
  },
  {
    key: 'content_type',
    label: 'Type',
  },
  // {
  //   key: 'byte_size',
  //   label: 'Size',
  //   sortable: true,
  //   formatContent: (row) => <>{bytesToSize(row.byte_size)}</>,
  // },
  {
    key: 'owner',
    label: 'Owner',
  },
  {
    key: 'created_at',
    label: 'Uploaded On',
    sortable: true,
    formatContent: (row) => <>{getDateAndTime(row.created_at)}</>,
  },
];

export const executionTableHeaders = [
  {
    key: 'key',
    label: 'Key',
    sortable: true,
    formatContent: (row) => {
      return (
        <Link
          to={`/project/${row.projectId}/testexecution/${row.key}?testcycle=${row.testCycleKey}&association=${row.testCaseKey}`}>
          <span style={{ whiteSpace: 'nowrap' }}>
            {row.key}
          </span>
        </Link>
      );
    },
  },
  {
    key: 'status',
    label: 'Status',
    formatContent: (row) => (
      <span
        title={row?.status?.name}
        style={{
          display: 'flex',
          alignItems: 'center',
        }}>
        <Circle sx={{ color: row?.status?.color }} />
        <span style={{ marginLeft: '5px' }}>{row?.status?.name}</span>
      </span>
    ),
  },
  // { key: 'assignedTo', label: 'Assigned To' },
  { key: 'executedBy', label: 'Executed By' },
  { key: 'environment', label: 'Environment' },
  { key: 'iteration', label: 'Iteration' },
  {
    key: 'actualTime',
    label: 'Actual Time',
    hoverText: 'Actual Time of the execution',
    formatContent: (row) => (
      <span>{row.actualTime ? formatElapsedTime(row.actualTime) : '-'}</span>
    ),
  },
  {
    key: 'executionTime',
    label: 'Execution Time',
    hoverText: 'Execution Time',
  },
  {
    key: 'linkedTo',
    label: 'Linked Issues',
    formatContent: (row) => <span>{row?.jiraIssueDetails?.length || 0}</span>,
  },
  {
    key: 'testCycle',
    label: 'Test Cycle',
    sortable: true,
    formatContent: (row) => {
      return (
        <Link
          to={`/project/${row.projectId}/testcycles/${row.testCycleKey}?type=testcases`}>
          {row.testCycleKey}
        </Link>
      );
    },
  },
];

export const IssueSearchTableHeaders = [
  {
    key: 'key',
    label: 'Key',
    sortable: false,
    formatContent: (row) => (
      <a
        href={`${row.siteUrl}/browse/${row.key}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fw-bold me-3 text-decoration-none">
        {row.key}
      </a>
    ),
  },
  {
    key: 'issuestatus',
    label: 'Status',
    sortable: false,
    formatContent: (row) => (
      <div className="badge bg-light text-dark px-2 py-1 rounded text-uppercase">
        {row.issuestatus}
      </div>
    ),
  },
  {
    key: 'issueType',
    label: 'Type',
    sortable: false,
    formatContent: (row) => {
      return (
        <>
          <IssueTypeIcon issueType={row.issueType} icon={row.issueTypeIcon} />
        </>
      );
    },
  },
  {
    key: 'summary',
    label: 'Summary',
    sortable: false,
    formatContent: (row) => (
      <span title={row?.summary} className="ellipsis">
        {row?.summary.length > 50
          ? `${row?.summary?.substring(0, 50)} ...`
          : row?.summary}
      </span>
    ),
  },
  {
    key: 'priority',
    label: 'Priority',
    sortable: false,
    formatContent: (row) => (
      <span className="badge text-dark py-1 rounded text-uppercase">
        <img
          src={row.priority_url}
          alt={row.priority}
          width="16"
          height="16"
          className="me-2"
        />
        {row.priority}
      </span>
    ),
  },
  { 
    key: 'labels',
    label: 'Labels',
    sortable: false,
    formatContent: (row) => {
      const labels = row.labels || [];

      if (labels.length === 0) return '-';

      const visibleLabels = labels.slice(0, 2);
      const remainingCount = labels.length - visibleLabels.length;

      return (
        <Tooltip title={labels.join(', ')} arrow placement="top">
        <span style={{ cursor: 'pointer' }}>
          <span style={{ fontSize: '15px' }}>
            {visibleLabels.join(', ')}
          </span>

        {remainingCount > 0 && (
          <span
            style={{
              marginLeft: 6,
              padding: '2px 6px',
              fontSize: '11px',
              fontWeight: 700,
              borderRadius: '10px',
              backgroundColor: '#e0e0e0',
              display: 'inline-block',
              lineHeight: 1,
            }}
          >
            ...+{remainingCount}
          </span>
        )}
      </span>

        </Tooltip>
      );
    },
  },
    { key: 'reporter', label: 'Reporter', sortable: false },
  ];

export const testStepsTableHeaders = [
  {
    key: '',
    label: '',
    sortable: false,
    width: '40px',
    formatContent: (row) => (
      <span
        style={{ cursor: 'grab' }}
        title="Drag and drop to change the step number">
        <DragIndicatorSharp />
      </span>
    ),
  },
  {
    key: 'sNo',
    label: 'S.No',
    sortable: true,
    width: '80px',
    formatContent: (row) => (
      <>
        {row.sNo}
        {row.is_cloned ? ` (CLONE)` : ''}
      </>
    ),
  },
  {
    key: 'step',
    label: 'Step',
    sortable: false,
    formatContent: (row) => renderLinks(row.step),
  },
  {
    key: 'testData',
    label: 'Test Data',
    sortable: false,
    formatContent: (row) => renderLinks(row.testData),
  },
  {
    key: 'expectedResult',
    label: 'Expected Result',
    sortable: false,
    formatContent: (row) => renderLinks(row.expectedResult),
  },
];

export const uriField = [
  {
    key: 'uri',
    label: 'URI',
    sortable: false,
    formatContent: (row) => renderLinks(row?.uri || ''),
  },
];

export const LoggedIssuestableHeaders = [
  {
    key: 'key',
    label: 'Issue Key',
    sortable: true,
    formatContent: (row) => (
      <a
        href={`${row.site_url}/browse/${row.key}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fw-bold me-3 text-decoration-none">
        {row.key}
      </a>
    ),
  },
  {
    key: 'summary',
    label: 'Summary',
    sortable: true,
    formatContent: (row) => {
      return (
        <div
          style={{
            width: '320px',
            wordWrap: 'break-word',
            whiteSpace: 'normal',
          }}>
          {row.summary}
        </div>
      );
    },
  },
  {
    key: 'issue_type',
    label: 'Type',
    sortable: true,
  },
  { key: 'issue_status', label: 'Status', sortable: true },
  {
    key: 'priority',
    label: 'Priority',
    sortable: true,
    formatContent: (row) => {
      const priority = row?.priority?.name;
      const color = getPriorityColor(priority);

      return priority ? (
        <span className="d-flex align-items-center">
          <div
            style={{
              width: 10,
              height: 10,
              backgroundColor: color,
              borderRadius: 2,
              marginRight: 6,
            }}
          />
          {priority}
        </span>
      ) : (
        '-'
      );
    },
  },
  {
    key: 'executions',
    label: 'Executions',
    hoverText: 'Executions linked to this issue',
    sortable: false,
    formatContent: (row) => (
      <div className="d-flex flex-column gap-2">
        {row.executions?.map((exec, idx) => (
          <div key={idx} className="border p-2 rounded bg-light">
            <div className="d-flex align-items-center justify-content-between gap-2">
              <div className="small">
                <Link
                  to={`/project/${row.project_id}/testexecution/${exec.execution_key}?testcycle=${exec.test_cycle_key}&association=${exec.test_case_key}`}>
                  {exec.execution_key}
                </Link>
              </div>
              <div className="small">
                <Link
                  to={`/project/${row.project_id}/testcases/${exec.test_case_key}`}>
                  {exec.test_case_key}
                </Link>
              </div>
              <div>
                <Badge
                  title={
                    exec.issue_label === 'New'
                      ? 'New issue(Issue created after the execution)'
                      : 'Existing issue(Issue created before the execution)'
                  }
                  bg={exec.issue_label === 'New' ? 'success' : 'primary'}
                  style={{ cursor: 'pointer' }}>
                  {exec.issue_label}
                </Badge>
              </div>
            </div>
          </div>
        ))}
      </div>
    ),
  },
];

export const dashboardTabs = [
  {
    key: 'testcase',
    label: 'Test Cases',
  },
  {
    key: 'testcycle',
    label: 'Test Cycles',
  },
  {
    key: 'issue',
    label: 'Issues',
  },
  {
    key: 'assignedForExecution',
    label: 'Assigned for Execution',
  },
  {
    key: 'assignedForReview',
    label: 'Assigned for Review',
  },
];

export const logsFields = [
  { key: 'sno', label: 'S.No.', alignRight: false, 
    formatContent: (row, index) => <>{index + 1}</>,
   },
  { key: 'method', label: 'Method', alignRight: false },
  { key: 'url', label: 'URL', alignRight: false },
  { key: 'status', label: 'Status', alignRight: false },
  {
    key: 'body',
    label: 'Error Message',
    alignRight: false,
    formatContent: (row) => (
      <span title={row?.body}>
        {row?.body}
      </span>

    ),
  },
  {
    key: 'data',
    label: 'Payload',
    alignRight: false,
    formatContent: (row) => (
      <FormattedJsonDisplay jsonString={row?.data} />
    ),
  },
  {
    key: 'created_at',
    label: 'Created At',
    alignRight: false,
    formatContent: (row) => <>{getDateAndTime(row.created_at)}</>,
  },
  { key: 'email', label: 'User email', alignRight: false },
];

export const TestPlanTableHeaders = [
  {
    key: 'key',
    label: 'Key',
    sortable: true,
    paramToPass: 'id',
    linkToId: 'testcases',
    formatContent: (row) => (
      <>
        <a
          href={`/project/${row?.gainss_project_id}/testcases/${row.key}`}
          target="_blank"
          rel="noopener noreferrer"
          className="fw-bold me-3 text-decoration-none">
          {row.key}
        </a>
      </>
    ),
  },
  {
    key: 'summary',
    label: 'Description',
    sortable: true,
    paramToPass: 'id',
    formatContent: (row) => (
      <span title={row?.summary} className="ellipsis">
        {row?.summary.length > 50
          ? `${row?.summary?.substring(0, 50)} ...`
          : row?.summary}
      </span>
    ),
  },
  {
    key: 'is_automated',
    label: 'Automated',
  },
  {
    key: 'module',
    label: 'Module',
  },
  {
    key: 'linkedIssues',
    label: 'Linked Issues',
    sortable: false,
    hoverText: 'Number of linked issues',
    formatContent: (row) => {
      return (
        <LinkedIssuesTooltip
          linkedIssues={row.issue_counts}
          totalIssues={row.total_issues}
        />
      );
    },
  },
  {
    key: 'status',
    label: 'Status',
    formatContent: (row) => (
      <span
        title={row?.status?.name}
        style={{
          display: 'flex',
          alignItems: 'center',
        }}>
        <Label color={row?.status?.color} name={row?.status?.name} />
      </span>
    ),
  },
];

export const ReleaseNoteTableHeaders = [
  {
    key: 'version',
    label: 'Version',
    sortable: true,
    paramToPass: 'version',
    formatContent: (row) => <span title={row?.version}>{row?.version}</span>,
  },
  {
    key: 'title',
    label: 'Title',
    sortable: true,
    paramToPass: 'title',
    formatContent: (row) => (
      <span title={row?.title} className="ellipsis">
        {row?.title.length > 50
          ? `${row?.title?.substring(0, 50)} ...`
          : row?.title}
      </span>
    ),
  },
  {
    key: 'released_at',
    label: 'Released At',
    sortable: true,
    formatContent: (row) => (
      <span>{formatDate(row?.released_at)}</span>
    ),
  },
  {
    key: 'status',
    label: 'Status',
    sortable: true,
    formatContent: (row) => (
      <Label
        color={row?.published ? 'green' : 'orange'}
        name={row?.published ? 'Published' : 'Draft'}
      />
    ),
  },
  {
    key: 'item_type_counts',
    label: 'Items',
    sortable: false,
    formatContent: (row) => {
      const counts = row?.item_type_counts || {};
      const entries = Object.entries(counts);

      return (
        <div
          title={entries
            .map(([type, count]) => `${type}: ${count}`)
            .join(', ')}>
          {entries.length > 0
            ? entries.map(([type, count]) => (
              <div key={type}>
                {type.charAt(0).toUpperCase() + type.slice(1)}: {count}
              </div>
            ))
            : '0'}
        </div>
      );
    },
  },
];

export const newIterationTableHead = [
  {
    key: 'key',
    label: 'Key',
    sortable: false,
  },
  {
    key: 'summary',
    label: 'Summary',
    sortable: false,
    formatContent: (row) => (
      <span title={row?.summary}>
        {row?.summary}
      </span>
    ),
  },
  {
    key: 'executionAssignedTo',
    label: 'Execution Assigned To',
    sortable: false,
  },
];